/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';

export const CpdsCopyrightGradient = styled.div.attrs({
  className: 'cpds-copyright-gradient',
})<{ isShow: boolean; borderRadius: string }>`
  ${({ isShow = false, borderRadius = '0px' }) => {
    return css`
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        0deg,
        rgba(41, 49, 66, 0) 0%,
        rgba(41, 49, 66, 0.22) 48.75%,
        rgba(41, 49, 66, 0.55) 100%
      );

      transition: all ease 0.25s;
      border-radius: ${borderRadius};
      z-index: ${isShow ? 12 : -1};
      opacity: ${isShow ? 1 : 0};
    `;
  }}
`;

export const CopyrightTextWrapper = styled.div<{
  isShow: boolean;
}>`
  display: flex;
  flex-direction: column;
  opacity: ${(props) => (props.isShow ? 1 : 0)};
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  overflow-wrap: break-word;
  text-align: right;
  transition: all ease 0.25s;
  justify-content: flex-end;
  z-index: 13;

  span {
    text-shadow: 1px 1px 2px #000;
    color: #ffffff;
    line-height: 18px;
    font-size: 12px;
  }
`;

const ICON_SIZES = {
  SM: {
    width: '20px',
    height: '15px',
  },
  MD: {
    width: '26px',
    height: '20px',
  },
  LG: {
    width: '36px',
    height: '28px',
  },
};

export const CopyrightButton = styled.button<{ iconSize: 'SM' | 'MD' | 'LG' }>`
  ${({ iconSize = 'LG' }) => {
    return css`
      background: transparent;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 13;
      svg {
        width: ${ICON_SIZES[iconSize].width};
        height: ${ICON_SIZES[iconSize].height};
      }
    `;
  }}
`;

const POS_CONFIG = {
  BOTTOM_RIGHT: {
    top: 'auto',
    bottom: '15px',
    right: '15px',
    left: 'auto',
    flexDirection: 'row',
    paddingLeft: '15px',
    paddingRight: '0',
    textAlign: 'right',
    marginRight: '25px',
    marginLeft: '0px',
    alignItems: 'flex-end',
  },
  BOTTOM_LEFT: {
    top: 'auto',
    bottom: '15px',
    right: 'auto',
    left: '15px',
    flexDirection: 'row-reverse',
    paddingLeft: '0',
    paddingRight: '15px',
    textAlign: 'left',
    marginRight: '0',
    marginLeft: '25px',
    alignItems: 'flex-end',
  },
  TOP_RIGHT: {
    top: '15px',
    bottom: 'auto',
    right: '15px',
    left: 'auto',
    flexDirection: 'row',
    paddingLeft: '15px',
    paddingRight: '0',
    textAlign: 'right',
    marginRight: '25px',
    marginLeft: '0px',
    alignItems: 'flex-start',
  },
  TOP_LEFT: {
    top: '15px',
    bottom: 'auto',
    right: 'auto',
    left: '15px',
    flexDirection: 'row-reverse',
    paddingLeft: '0',
    paddingRight: '15px',
    textAlign: 'left',
    marginRight: '0',
    marginLeft: '25px',
    alignItems: 'flex-start',
  },
};

export const CpdsCopyrightWrapper = styled.div`
  ${({ position = 'BOTTOM_RIGHT' }) => {
    return css`
      position: absolute;
      z-index: 13;
      display: flex;
      top: ${POS_CONFIG[position].top};
      bottom: ${POS_CONFIG[position].bottom};
      right: ${POS_CONFIG[position].right};
      left: ${POS_CONFIG[position].left};
      flex-direction: ${POS_CONFIG[position].flexDirection};
      padding-left: ${POS_CONFIG[position].paddingLeft};
      padding-right: ${POS_CONFIG[position].paddingRight};
      align-items: ${POS_CONFIG[position].alignItems};
      border-radius: 0px !important;
      ${CopyrightTextWrapper} {
        span {
          margin-right: ${POS_CONFIG[position].marginRight};
          margin-left: ${POS_CONFIG[position].marginLeft};
          text-align: ${POS_CONFIG[position].textAlign};
        }
      }
      ${(props) => props?.styleOverrides}
    `;
  }}
`;
